namespace $ {

	type Entry = { fqn: string, links: string[] }

	/** Advisory native-read manifest. Never contains source, compiled code or rights. */
	export class $shm_hitalama_map_component_preparation_hints extends $mol_object {

		storage_key() {
			const principal = this.$.$giper_baza_auth.current().pass().lord().str
			const domain = this.$.$shm_hitalama_domain.domain_link()
			return '$shm_hitalama_map_component_preparation_hints:v1:' + JSON.stringify([ principal, domain ])
		}

		entries( next?: Entry[] ): Entry[] {
			return this.$.$mol_error_fence( ()=> {
				const value = this.$.$mol_state_local.value< unknown >( this.storage_key(), next )
				if( !Array.isArray( value ) ) return []
				return value.slice( 0, 8 ).flatMap( entry => {
					if( typeof entry?.fqn !== 'string' || !Array.isArray( entry?.links ) ) return []
					const links = entry.links.slice( 0, 128 ).filter( ( id: unknown ): id is string => typeof id === 'string' && id.length <= 100 )
					return [{ fqn: entry.fqn, links }]
				} )
			}, ()=> [], ()=> [] )
		}

		@ $mol_mem_key
		warm( fqn: string ) {
			const entry = this.entries().find( entry => entry.fqn === fqn )
			if( !entry ) return 0
			for( const id of entry.links ) this.$.$mol_error_fence( ()=> {
				const node = this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( id ), this.$.$shm_hitalama_map_widget )
				node.units()
			}, ()=> null, ()=> null )
			// Only the normal graph may decide whether code is current and readable.
			return entry.links.length
		}

		@ $mol_action
		remember( fqn: string, graph: readonly { definition: $shm_hitalama_map_widget_entity_custom }[] ) {
			const links = new Set< string >
			for( const { definition } of graph ) {
				links.add( definition.link().str )
				for( const kind of [ 'tree', 'logic', 'style' ] as const ) {
					const source = definition.source_link( kind )
					if( source ) links.add( source.link().str )
				}
				if( links.size >= 128 ) break
			}
			const entry = { fqn, links: [ ...links ].slice( 0, 128 ) }, current = this.entries()
			const previous = current.find( item => item.fqn === fqn )
			if( previous && JSON.stringify( previous.links ) === JSON.stringify( entry.links ) ) return false
			this.entries([ entry, ...current.filter( item => item.fqn !== fqn ) ].slice( 0, 8 ))
			return true
		}

	}

}
